/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
/**
 * simple shader to invert the color channels form rgb to bgr
 */
export const BGR_SWIZZLE_SHADER = {
    uniforms: {
        texture: { value: null },
    },
    vertexShader: `
        varying vec2 vUv;
        void main()
        {
          vUv = uv;
          gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
        }
    `,
    fragmentShader: `
        uniform sampler2D texture;
        varying vec2 vUv;
        void main()
        {
          gl_FragColor = texture2D( texture, vUv ).bgra;
        }
    `,
};
//# sourceMappingURL=ShaderTools.js.map